import React, { FC } from 'react';

import { ResponseStatus } from 'src/generated/mloop-graphql';

import AvatarWithBadge from './AvatarWithBadge';
import InterviewerRsvpIcon from './InterviewerRsvpIcon';

type AvatarSize = 16 | 20 | 28 | 32 | 40 | 80 | 120 | 210;

interface AvatarWithRsvpProps {
  responseStatus: ResponseStatus | undefined | null;
  dataTestId?: string;
  src?: string;
  outlineOffset?: string;
  alt: string;
  interviewerRsvpIconDataTestId?: string;
  size?: AvatarSize;
}

/** Avatar with RSVP badge and outline styling that reflects declined status. */
const AvatarWithRsvp: FC<AvatarWithRsvpProps> = ({
  dataTestId,
  interviewerRsvpIconDataTestId,
  outlineOffset,
  responseStatus,
  src,
  alt,
  size,
}) => {
  const offset = outlineOffset ?? '-1px';
  const isDeclined = responseStatus === ResponseStatus.Declined;

  return (
    <AvatarWithBadge
      dataTestId={dataTestId}
      size={size}
      icon={<InterviewerRsvpIcon dataTestId={interviewerRsvpIconDataTestId} responseStatus={responseStatus} />}
      src={src}
      alt={alt}
      avatarProps={{
        sx: (theme) => ({
          outline: `1px solid ${isDeclined ? theme.palette.error.main : theme.palette.border}`,
          outlineOffset: offset,
        }),
      }}
    />
  );
};

export default AvatarWithRsvp;
